import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { ShipmentStopsParams } from '@api/order-reporting/types/ShipmentStopsParams';
import { ShipmentStopsReport } from '@api/order-reporting/types/ShipmentStopsReport';
import { convertToGridData } from '@pages/reporting-pages/shipment-stops/store/convertors';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';



interface ReportingShipmentStopsState {
	gridData: ShipmentStopsGridData[] | null,
	date: string | null,
	customerId: string | null,
	tileId: string | null,
};

const initialState: ReportingShipmentStopsState = {
	gridData: null,
	date: null,
	customerId: null,
	tileId: null,
};



export const reportingShipmentStopsSlice = createSlice({
	name: 'reportingShipmentStops',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<ShipmentStopsReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDate: (state, action: PayloadAction<string>) => {
			state.date = action.payload;
		},
		setCustomerId: (state, action: PayloadAction<string | null>) => {
			state.customerId = action.payload;
		},
		setTileId: (state, action: PayloadAction<string | null>) => {
			state.tileId = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<ShipmentStopsParams>) => {
			let stateFromWithoutTime = state.date ? getDateWithoutTime(state.date) : null;
			if (action.payload.day !== stateFromWithoutTime) {
				state.date = action.payload.day;
			}
			if (action.payload.customerId !== state.customerId) {
				state.customerId = action.payload.customerId ? action.payload.customerId : null;
			}
			if (action.payload.tileId !== state.tileId) {
				state.tileId = action.payload.tileId ? action.payload.tileId : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDate,
	setCustomerId,
	setTileId,
	setSearchParameters,
	resetStore } = reportingShipmentStopsSlice.actions;